import axios from 'axios'
import { API_URL } from '../api.js'

const api = `${API_URL}/order`

export default {
    async getOrders(restaurantId, status, includeOrderId) {
        let url = `${api}/${restaurantId}`
        if (status && includeOrderId) url += `?status=${status}&includeOrderId=${includeOrderId}`
        else if (status) url += `?status=${status}`
        else if (includeOrderId) url += `?includeOrderId=${includeOrderId}`
        const resp = await axios.get(url);
        return resp.data;
    },
    async confirmOrder(restaurantId, orderId, subject, message) {
        const resp = await axios.post(`${api}/confirm`, { restaurantId, orderId, subject, message })
        return resp.data
    },
    async rejectOrder(restaurantId, orderId, subject, message) {
        const resp = await axios.post(`${api}/reject`, { restaurantId, orderId, subject, message })
        return resp.data
    },
    async completeOrder(restaurantId, orderId) {
        const resp = await axios.post(`${api}/complete`, { restaurantId, orderId })
        return resp.data
    }
}